import {EnumLanguage} from "../EnumLanguage";

export const UXContacts = {
    address: {
        [EnumLanguage.ru]: 'г. Москва, Лаврушинский переулок, 10',
        [EnumLanguage.en]: 'Moscow, Lavrushinsky lane, 10',
        [EnumLanguage.cn]: '莫斯科，Lavrushinsky 巷，10'
    },
    phone: {
        [EnumLanguage.ru]: '+7 (495) 957-07-16',//'8 (495) 957-07-27',
        [EnumLanguage.en]: '+7 (495) 957-07-16',
        [EnumLanguage.cn]: '+7 (495) 957-07-16'
    },
    email: {
        [EnumLanguage.ru]: 'misgtg@tretyakov.ru',
        [EnumLanguage.en]: 'misgtg@tretyakov.ru',
        [EnumLanguage.cn]: 'misgtg@tretyakov.ru'
    },
    schedule: {
        [EnumLanguage.ru]: 'ПН-ЧТ: 9:00 — 18:00, ПТ: 9:00 — 15:30',
        [EnumLanguage.en]: 'MON-FRI: 9AM - 6PM, FRI: 9AM - 3:30PM',
        [EnumLanguage.cn]: '周一至周五：9:00 - 18:00，周五：9:00 - 15:30'
    }

}